import { Component } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../service";
import * as i2 from "../../../../basic-features/button-v2/button.component";
import * as i3 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
function ButtonsRendererComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 2);
    i0.ɵɵlistener("click", function ButtonsRendererComponent_For_2_Template_geaui_button_v2_click_0_listener() {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.buttonClicked(button_r2.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵproperty("postIcon", button_r2.postIcon)("preIcon", button_r2.preIcon)("preIconBaseUrl", button_r2.preIconBaseUrl)("flex", button_r2.flex);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, button_r2.text), " ");
  }
}
export class ButtonsRendererComponent {
  tableService;
  config;
  rowData;
  columnKey;
  tableId;
  constructor(tableService) {
    this.tableService = tableService;
  }
  buttonClicked(action) {
    if (!this.tableId) {
      throw new Error('No table Id');
    }
    this.tableService.publishAction(this.tableId, action, this.rowData);
  }
  static ɵfac = function ButtonsRendererComponent_Factory(t) {
    return new (t || ButtonsRendererComponent)(i0.ɵɵdirectiveInject(i1.TableServiceV2));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonsRendererComponent,
    selectors: [["geaui-buttons-renderer"]],
    decls: 3,
    vars: 0,
    consts: [[1, "buttons"], [3, "postIcon", "preIcon", "preIconBaseUrl", "flex"], [3, "click", "postIcon", "preIcon", "preIconBaseUrl", "flex"]],
    template: function ButtonsRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵrepeaterCreate(1, ButtonsRendererComponent_For_2_Template, 3, 7, "geaui-button-v2", 1, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.config.buttons);
      }
    },
    dependencies: [i2.ButtonV2Component, i3.TranslatePipe],
    styles: ["[_nghost-%COMP%]{position:relative}[_nghost-%COMP%]   .buttons[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start;gap:8px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonsRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-buttons-renderer',
      template: "<div class=\"buttons\">\n  @for (button of config.buttons; track $index) {\n    <geaui-button-v2\n      [postIcon]=\"button.postIcon\"\n      [preIcon]=\"button.preIcon\"\n      [preIconBaseUrl]=\"button.preIconBaseUrl\"\n      [flex]=\"button.flex\"\n      (click)=\"buttonClicked(button.action)\">\n      {{ button.text | translate }}\n    </geaui-button-v2>\n  }\n</div>\n",
      styles: [":host{position:relative}:host .buttons{display:flex;align-items:center;justify-content:flex-start;gap:8px}\n"]
    }]
  }], () => [{
    type: i1.TableServiceV2
  }], null);
})();
